import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { campaignsService, Campaign, CampaignManagersRequest } from '@aslanpay/portal-common-lib';

interface CampaignManagersMutation extends CampaignManagersRequest {
  campaignId: string;
}

const useAppointCampaignManagers = (
  options: UseMutationOptions<Campaign, Error, CampaignManagersMutation>
) => {
  return useMutation<Campaign, Error, CampaignManagersMutation>(
    ({ campaignId, individualIds }) =>
      campaignsService.appointCampaignManagers(campaignId, { individualIds }),
    options
  );
};

const useRemoveCampaignManagers = (
  options: UseMutationOptions<Campaign, Error, CampaignManagersMutation>
) => {
  return useMutation<Campaign, Error, CampaignManagersMutation>(
    ({ campaignId, individualIds }) =>
      campaignsService.removeCampaignManagers(campaignId, { individualIds }),
    options
  );
};

export default { useAppointCampaignManagers, useRemoveCampaignManagers };
